import DefaultBuilder from './default-builder';
import ClassicBuilder from './classic-builder';
import BuilderInterface from 'src/components/organisms/players-to-exchange/available-players/builder-interface';
import PlayerBuilderInterface from 'components/organisms/players-to-exchange/available-players/player-builder-interface';

export default class BuilderFactory implements PlayerBuilderInterface {
    createClassicBuilder(sportConfig): BuilderInterface {
        return new ClassicBuilder(sportConfig);
    }

    createTiersBuilder(sportConfig): BuilderInterface | never {
        throw new Error('Not Implemented');
    }

    createShowDownBuilder(sportConfig): BuilderInterface {
        return new DefaultBuilder(sportConfig);
    }

    createSingleGameBuilder(sportConfig): BuilderInterface {
        return new DefaultBuilder(sportConfig);
    }
}
